module.exports = __webpack_public_path__ + "src/assets/operator-logos-mono/scougar.svg";